import {
  PROGRAMA_RECOMPENSA_LOAD_SALDO_CLIENTE,
  PROGRAMA_RECOMPENSA_AJUSTAR_SALDO,
  PROGRAMA_RECOMPENSA_EXPORTAR_SALDOS,
  PROGRAMA_RECOMPENSA_BUSCAR_CLIENTES_CRITERIO
} from "../actions/programaRecompensa";
import { ERRORS_SHOW } from "../actions/errors";
import Api from "../../service/api-web";

const state = {};

const getters = {};

const actions = {
  [PROGRAMA_RECOMPENSA_LOAD_SALDO_CLIENTE]: (
    { dispatch, getters },
    payload
  ) => {
    return new Promise((resolve, reject) => {
      const idfornecedor = getters.getFornecedorId;
      const idcliente = payload && payload.idcliente;
      if (!idfornecedor || !idcliente) {
        reject(new Error("Missing supplier or customer id"));
        return;
      }
      Api.v4.programaRecompensa
        .obterSaldoCliente(idfornecedor, idcliente)
        .then(resp => {
          const data = resp.data || {};
          resolve({
            saldo_confirmado:
              data.saldo_confirmado != null
                ? String(data.saldo_confirmado)
                : "0",
            saldo_pendente:
              data.saldo_pendente != null ? String(data.saldo_pendente) : "0",
            saldo_expirado:
              data.saldo_expirado != null ? String(data.saldo_expirado) : "0",
            data_atualizacao: data.data_atualizacao,
            has_record: data.has_record
          });
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PROGRAMA_RECOMPENSA_AJUSTAR_SALDO]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      const idfornecedor = getters.getFornecedorId;
      if (!idfornecedor) {
        reject(new Error("Missing supplier id"));
        return;
      }
      const headers = {};
      if (payload && payload.idempotencyKey) {
        headers["idempotency-key"] = payload.idempotencyKey;
      }
      Api.v4.programaRecompensa
        .ajustarSaldo(
          idfornecedor,
          {
            customer_id: payload.customer_id,
            tipo_operacao: payload.tipo_operacao,
            pontos: payload.pontos,
            motivo: payload.motivo
          },
          headers
        )
        .then(resp => resolve(resp.data))
        .catch(err => {
          const status = err.response && err.response.status;
          if (status !== 422) {
            dispatch(ERRORS_SHOW, err);
          }
          reject(err);
        });
    });
  },
  [PROGRAMA_RECOMPENSA_EXPORTAR_SALDOS]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      const idfornecedor = getters.getFornecedorId;
      if (!idfornecedor) {
        reject(new Error("Missing supplier id"));
        return;
      }
      Api.v4.programaRecompensa
        .exportarSaldos(idfornecedor, payload.queryString || "")
        .then(resp => resolve(resp))
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PROGRAMA_RECOMPENSA_BUSCAR_CLIENTES_CRITERIO]: (
    { dispatch, getters },
    payload
  ) => {
    return new Promise((resolve, reject) => {
      const idfornecedor = getters.getFornecedorId;
      if (!idfornecedor) {
        resolve([]);
        return;
      }
      Api.v4.programaRecompensa
        .buscarClientesCriterio(idfornecedor, (payload && payload.search) || "")
        .then(resp => {
          const items = Array.isArray(resp.data) ? resp.data : [];
          resolve(
            items.map(item => ({
              value: item.idcliente,
              text: item.nome || item.email || item.idcliente
            }))
          );
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
